import React, { useLayoutEffect, useState } from "react"
import TableBody from "@mui/material/TableBody"
import TableRow from "@mui/material/TableRow"
import TableCell from "@mui/material/TableCell"
import Skeleton from "@mui/material/Skeleton"
import { TableBodyProps } from "@mui/material/TableBody/TableBody"

type TableSkeletonProps = {
  rows: number
  columns: number
  delay?: number
  fadingAway?: boolean
} & TableBodyProps

export const TableSkeleton = ({
  rows,
  columns,
  delay,
  fadingAway,
  ...props
}: TableSkeletonProps) => {
  const [visible, setVisible] = useState(false)

  useLayoutEffect(() => {
    if (delay) {
      const timeout = setTimeout(() => setVisible(true), delay)
      return () => clearTimeout(timeout)
    } else {
      setVisible(true)
    }
  }, [])

  if (!rows || !columns || !visible) {
    return null
  }

  const opacity = (index) => 1 - (index / (rows - 1)) * (fadingAway ? 0.5 : 0)

  return (
    <TableBody {...props}>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columns }).map((_, columnIndex) => (
            <TableCell
              key={columnIndex}
              className="duration-100"
              style={{ opacity: opacity(rowIndex) }}
            >
              <Skeleton variant="text" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  )
}
